import { useLingui } from '@lingui/react/macro';
import { toast } from '@utima/ui';

import { useUser } from '@/hooks';
import { trpc } from '@/services/trpc';

export function useUserMutation() {
  const { t } = useLingui();
  const { user } = useUser();
  const utils = trpc.useUtils();

  const create = trpc.users.create.useMutation({
    onSuccess: async () => utils.users.findAll.invalidate(),
  });

  const update = trpc.users.update.useMutation({
    onSuccess: async (data, { id }) => {
      await Promise.all([
        utils.users.findAll.invalidate(),
        utils.users.findOne.invalidate({ id }),
        user?.id === id ? utils.users.me.invalidate() : null,
      ]);
    },
  });

  const remove = trpc.users.delete.useMutation({
    onSuccess: async (data, { id }) => {
      await utils.users.findAll.invalidate();
    },
  });

  const removeFromOrganization = trpc.users.removeFromOrganization.useMutation({
    onSuccess: async (data, { userId, organizationId }) => {
      await utils.users.findAll.invalidate();
      toast.success(t`User removed`, {
        description: t`User was successfully removed from the organization`,
      });
    },
    onError: () => {
      toast.error(t`Removal failed`, {
        description: t`Failed to remove user from organization`,
      });
    },
  });

  return {
    create,
    update,
    remove,
    removeFromOrganization,
  };
}
